// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1u_RV","buttons":"styles_buttons__39l53"};